module.exports = __webpack_public_path__ + "img/abc.da613407.png";